import {
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";

import Btn from "../../../../components/buttons/Btn";
import TextFieldErp from "../../../../components/basics/TextFieldErp";
import SelectErp from "../../../../components/basics/SelectErp";
import useFornecedorController from "../controllers/FornecedorController";
import { useContext, useEffect, useState } from "react";
import { FornecedorContext } from "../contexts/FornecedorContext";
import { validNotNull, validEmail } from "../../../../utils/validations";
import { notify } from "../../../../utils/notify";
import { v4 as uuidv4 } from "uuid";

export default function ModalFornecedorContato({
  open,
  setOpen,
  rowEdit,
  setRowEdit,
}) {
  const {
    //Dados Gerais
    generalCustomerId,

    contacts,
    setContacts,
    listUf,
    listCounty,
  } = useContext(FornecedorContext);
  const { handleChangeCep } = useFornecedorController();

  const [contactErrors, setContactErrors] = useState({});
  const [contactName, setContactName] = useState("");
  const [contactEmail, setContactEmail] = useState("");
  const [contactRamal, setContactRamal] = useState("");
  const [contactTelephone, setContactTelephone] = useState("");
  const [contactDepartament, setContactDepartament] = useState("");
  const [contactCep, setContactCep] = useState("");
  const [contactAddress, setContactAddress] = useState("");
  const [contactNumber, setContactNumber] = useState("");
  const [contactComplement, setContactComplement] = useState("");
  const [contactDistrict, setContactDistrict] = useState("");
  const [contactUf, setContactUf] = useState(null);
  const [contactCounty, setContactCounty] = useState("");

  useEffect(() => {
    if (!rowEdit) {
      setContactName("");
      setContactEmail("");
      setContactTelephone("");
      setContactRamal("");
      setContactDepartament("");
      setContactCep("");
      setContactAddress("");
      setContactNumber("");
      setContactDistrict("");
      setContactUf(null);
      setContactCounty("");
      return;
    }

    setContactName(rowEdit.nome);
    setContactEmail(rowEdit.email);
    setContactTelephone(rowEdit.ddd + " " + rowEdit.telefone);
    setContactRamal(rowEdit.ramal);
    setContactDepartament(rowEdit.dpto);
    setContactCep(rowEdit.cep);
    setContactAddress(rowEdit.endereco);
    setContactNumber(rowEdit.numero);
    setContactDistrict(rowEdit.bairro);
    setContactUf(null);

    if (rowEdit.municipio_codigo && rowEdit.id_estado) {
      setContactCounty(
        listCounty.find(
          (opt) => opt.codigo === rowEdit.municipio_codigo.toString()
        ) || null
      );
      setContactUf(listUf.find((opt) => opt.id === rowEdit.id_estado) || null);
    }
    // eslint-disable-next-line
  }, [rowEdit]);

  const handleCloseModal = () => {
    setContactErrors({});
    setOpen(false);
    setRowEdit(null);
  };

  const handleAdd = () => {
    const resultValidation = validNotNull([
      { value: contactName, key: "contactName" },
      { value: contactEmail, key: "contactEmail" },
      { value: contactTelephone, key: "contactTelephone" },
    ]);

    if (contactEmail && !validEmail(contactEmail)) {
      notify("E-mail inválido");
      resultValidation.errorsValidation.contactEmail = "E-mail inválido";
      resultValidation.error = true;
    }

    if (resultValidation.error) {
      setContactErrors(resultValidation.errorsValidation);
      return notify("Verifique se os campos obrigatórios estão preenchidos.");
    }

    const tel = contactTelephone.split(" ");
    const body = {
      nome: contactName,
      email: contactEmail,
      dpto: contactDepartament,
      ddd: tel[0].replace(/[^0-9]+/g, ""),
      cep: contactCep.replace(/[^0-9]+/g, ""),
      endereco: contactAddress,
      numero: contactNumber,
      cidade: contactCounty ? contactCounty.municipio : null,
      municipio_codigo: contactCounty ? contactCounty.codigo : null,
      id_estado: contactUf ? contactUf.id : null,
      bairro: contactDistrict,
      complemento: contactComplement,
      telefone: tel[1].replace(/[^0-9]+/g, ""),
      ramal: contactRamal,
      id: uuidv4(),
    };
    if (generalCustomerId) body.idFornecedors = generalCustomerId;

    if (rowEdit && rowEdit?.id) {
      const copyContacts = [...contacts];
      const index = contacts.findIndex((cont) => cont.id === rowEdit.id);
      copyContacts[index] = body;
      setContacts(copyContacts);
    } else {
      body.id = uuidv4();
      const copy = [...contacts];
      copy.push(body);
      setContacts(copy);
    }

    setContactName("");
    setContactEmail("");
    setContactTelephone("");
    setContactRamal("");
    setContactDepartament("");
    setContactCep("");
    setContactAddress("");
    setContactNumber("");
    setContactDistrict("");
    setContactUf(null);
    setContactCounty("");
    setOpen(false);
    setRowEdit(null);
  };

  return (
    <>
      <Dialog
        open={open}
        maxWidth="lg"
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {rowEdit && rowEdit.id
            ? `Edição de contato: ${rowEdit.nome}`
            : "Cadastro de Contato"}
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={1} justifyContent="flex-start">
            <Grid item lg={4} md={6} sm={6} xs={12}>
              <TextFieldErp
                label="Nome"
                maxLength={50}
                value={contactName}
                setValue={setContactName}
                error={contactErrors.contactName ? true : false}
              />
            </Grid>

            <Grid item lg={3} md={6} sm={6} xs={12}>
              <TextFieldErp
                label="Email"
                maxLength={50}
                value={contactEmail}
                setValue={setContactEmail}
                error={contactErrors.contactEmail ? true : false}
              />
            </Grid>

            <Grid item lg={3} md={6} sm={6} xs={12}>
              <TextFieldErp
                label="Telefone"
                maxLength={50}
                value={contactTelephone}
                setValue={setContactTelephone}
                mask="cel-phone"
                error={contactErrors.contactTelephone ? true : false}
              />
            </Grid>

            <Grid item lg={2} md={6} sm={6} xs={12}>
              <TextFieldErp
                label="Ramal"
                maxLength={50}
                value={contactRamal}
                setValue={setContactRamal}
              />
            </Grid>

            <Grid item lg={3} md={6} sm={6} xs={12}>
              <TextFieldErp
                label="Departamento"
                maxLength={50}
                value={contactDepartament}
                setValue={setContactDepartament}
              />
            </Grid>

            <Grid item lg={2} md={6} sm={6} xs={12}>
              <TextFieldErp
                label="CEP"
                maxLength={50}
                value={contactCep}
                onChange={(e) =>
                  handleChangeCep(e, null, {
                    setCep: setContactCep,
                    setAddress: setContactAddress,
                    setComplement: setContactComplement,
                    setCounty: setContactCounty,
                    setUf: setContactUf,
                    setDistrict: setContactDistrict,
                  })
                }
                mask="cep"
                InputProps={{
                  endAdornment: <SearchIcon onClick={() => {}} />,
                }}
              />
            </Grid>

            <Grid item lg={5} md={6} sm={6} xs={12}>
              <TextFieldErp
                label="Endereço"
                maxLength={50}
                value={(contactAddress || "").slice(0, 50)}
                setValue={setContactAddress}
              />
            </Grid>

            <Grid item lg={2} md={6} sm={6} xs={12}>
              <TextFieldErp
                label="Número"
                maxLength={50}
                value={contactNumber}
                setValue={setContactNumber}
              />
            </Grid>

            <Grid item lg={4} md={6} sm={6} xs={12}>
              <TextFieldErp
                label="Bairro"
                maxLength={30}
                value={(contactDistrict || "").slice(0, 30)}
                setValue={setContactDistrict}
              />
            </Grid>

            <Grid item lg={2} md={6} sm={6} xs={12}>
              <SelectErp
                loading={false}
                label="Estado"
                value={contactUf}
                setValue={setContactUf}
                optionsList={listUf}
                descriptionField="estado"
              />
            </Grid>

            <Grid item lg={4} md={6} sm={6} xs={12}>
              <SelectErp
                loading={false}
                label="Municipio"
                value={contactCounty}
                setValue={setContactCounty}
                optionsList={
                  contactUf
                    ? listCounty.filter(
                        (opt) => opt.estado_codigo === contactUf.codibge
                      )
                    : []
                }
                descriptionField="municipio"
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Btn label="Cancelar" bgcolor="tertiary" onClick={handleCloseModal} />
          <Btn label="Salvar" onClick={handleAdd} />
        </DialogActions>
      </Dialog>
    </>
  );
}
